export const FILE_UPLOAD_REJECTED  = "FILE_UPLOAD_REJECTED";
export const FILE_UPLOAD_REJECTED_TOO_BIG  = "FILE_UPLOAD_REJECTED_TOO_BIG";

export const IMAGE_FETCH_REJECTED  = "IMAGE_FETCH_REJECTED";
